import styled from 'styled-components'

type Props = {
	isFullWidth?: boolean | undefined
}

export const FieldWrapper = styled.div<Props>`
	display: ${({ isFullWidth }) => (isFullWidth ? 'block' : 'inline-block')};
	width: ${({ isFullWidth }) => (isFullWidth ? '100%' : 'auto')};
	height: auto;
	margin-bottom: 20px;
	min-width: auto;
	overflow: visible;
`
